import "../styles/section5.css";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";

const Section5 = () => {
  // const [username, setUsername] = useState("");
  // const [email, setEmail] = useState("");
  // const [message, setMessage] = useState("");



  const [contacts, setContacts]= useState({
    name: "",
    email: "",
    message: ""
  })

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setContacts((prev)=>({
      ...prev, 
      [name] : value,
    }))
  }

  const handleSubmit = async (e) => {
    Swal.fire({
      title: "Successfully Submitted",
      icon: "success",
      draggable: true,
    });
    e.preventDefault();
        
       fetch('https://jrglobalservices.com/api/saveContact.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contacts)
    })
      .then(response => response.json())
      .then(data => {
        alert(data.message);
      })
      .catch(error => {
        console.error('Error:', error);
      });
       setContacts({
        name: '',
        email: '',
        message: '',
      });
  };
 

  return (
    <div className="section5">
      <div className="contactWrapper">
        <div className="title">
          <h1>contact us form</h1>
        </div>
        <form name="contactForm" className="contactForm" onSubmit={handleSubmit}>
          <div className="inputFields">
            <input
              type="text"
              className="input"
              name="name"
              value={contacts.name}
              onChange={handleInputChange}
              placeholder="Enter your name"
            />
            <input
              type="email"
              className="input"
              placeholder="Enter email Address"
              name="email"
              value={contacts.email}
               onChange={handleInputChange}
            />
    
          </div>
          <div className="msg">
            <textarea
              type="text"
              name="message"
              value={contacts.message}
              onChange={handleInputChange}
              placeholder="Enter your message"
            ></textarea>
            <button type="submit" className="btn btn-outline-warning">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Section5;
